export class LiquidCardElement extends HTMLElement {
  public static get observedAttributes() {
    return ['radius', 'blur', 'tint-color', 'tint-opacity'];
  }

  private shadowRootRef: ShadowRoot;

  constructor() {
    super();
    this.shadowRootRef = this.attachShadow({ mode: 'open' });
    this.render();
  }

  connectedCallback() {
    this.updateStyles();
  }

  attributeChangedCallback() {
    this.updateStyles();
  }

  get radius(): number {
    return parseFloat(this.getAttribute('radius') || '28');
  }
  set radius(val: number) {
    this.setAttribute('radius', val.toString());
  }

  private updateStyles() {
    const r = this.radius;
    const blur = this.getAttribute('blur') || '24px';
    const cardEl = this.shadowRootRef.querySelector('.liquid-card') as HTMLElement;
    if (cardEl) {
      cardEl.style.setProperty('--card-radius', `${r}px`);
      cardEl.style.setProperty('--card-blur', blur.includes('px') ? blur : `${blur}px`);
    }
  }

  private render() {
    this.shadowRootRef.innerHTML = `
      <style>
        :host {
          display: block;
          box-sizing: border-box;
          width: 100%;
        }

        .liquid-card {
          position: relative;
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          border-radius: var(--card-radius, 28px);
          background: rgba(255, 255, 255, 0.07);
          backdrop-filter: blur(var(--card-blur, 24px)) saturate(1.8);
          -webkit-backdrop-filter: blur(var(--card-blur, 24px)) saturate(1.8);
          border: 1px solid rgba(255, 255, 255, 0.18);
          box-shadow: 
            inset 0 1px 2px 0 rgba(255, 255, 255, 0.35),
            inset 0 -1px 2px 0 rgba(0, 0, 0, 0.1),
            0 12px 36px 0 rgba(0, 0, 0, 0.22);
          color: #ffffff;
          overflow: hidden;
          padding: 28px;
        }
      </style>
      <div class="liquid-card">
        <slot></slot>
      </div>
    `;
  }
}
